import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";

export default function Navbar(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const serviceLinks = [
    { label: "J-Mobile Voice & Data", to: "/plans/mobile" },
    { label: "J-Data NBN", to: "/plans/nbn" },
    { label: "J-Data Fibre", to: "/plans/business-fibre" },
    { label: "J-Voice SIP", to: "/plans/sip-trunking" },
    { label: "J-Voice Hosted", to: "/plans/hosted-voice" },
    { label: "J-Voice Microsoft Teams", to: "/plans/hosted-teams" },
    { label: "Keep Up With Technology", to: "/plans/keep-up-with-technology" },
    { label: "J-Voice Inbound", to: "/plans/inbound-calls" },
    { label: "Web Design & Development", to: "/plans/web-design" },
    { label: "Digital Marketing", to: "/plans/social-media-marketing" }
  ];

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/plans", label: "Products & Services", dropdown: true },
    { to: "/wholesale", label: "Wholesale" },
    { to: "/hardware", label: "Hardware" },
    { to: "/newsroom", label: "Newsroom" },
    { to: "/about", label: "About Us" },
    { to: "/contact", label: "Contact Us" },
    {
      to: "https://accountinfo.com.au/index.php?r=site/login",
      label: "My Account",
      external: true
    }
  ];

  return (
    <header className="site-header">
      <div className="header-gradient" />

      <div className="container header-inner">
        {/* LOGO */}
        <div className="brand">
          <Link to="/" onClick={() => setOpen(false)}>
            <img
              src="/assets/Blue Logo.png"
              alt="Jortel Logo"
              className="brand-logo"
            />
          </Link>
        </div>

        {/* DESKTOP NAV */}
        <nav className={`main-nav ${open ? "open" : ""}`}>
          {navLinks.map(({ to, label, external, dropdown }) => {
            if (dropdown) {
              return (
                <div
                  key={label}
                  className="nav-dropdown"
                  onMouseEnter={() => setDropdownOpen(true)}
                  onMouseLeave={() => setDropdownOpen(false)}
                >
                  <NavLink to={to} className="nav-link">
                    {label}
                  </NavLink>

                  {/* Mega Menu */}
                  <div className={`mega-menu ${dropdownOpen ? "open" : ""}`}>
                    <div className="mega-menu__grid">
                      {serviceLinks.map((item) => (
                        <Link
                          key={item.to}
                          to={item.to}
                          className="mega-item"
                          onClick={() => setOpen(false)}
                        >
                          {item.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              );
            }

            return external ? (
              <a
                key={label}
                href={to}
                className="nav-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {label}
              </a>
            ) : (
              <NavLink
                key={label}
                to={to}
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                {label}
              </NavLink>
            );
          })}
        </nav>

        {/* MOBILE TOGGLE */}
        <button
          className="mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="mobile-menu">
          {navLinks.map(({ to, label, dropdown, external }) =>
            dropdown ? (
              <div key={label} className="mobile-dropdown">
                <div
                  className="mobile-nav-link"
                  onClick={() => setDropdownOpen((d) => !d)}
                >
                  {label}
                </div>

                <div
                  className={`mobile-submenu ${
                    dropdownOpen ? "open" : ""
                  }`}
                >
                  {serviceLinks.map((item) => (
                    <Link
                      key={item.to}
                      to={item.to}
                      className="mobile-sub-link"
                      onClick={() => setOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            ) : external ? (
              <a
                key={label}
                href={to}
                className="mobile-nav-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {label}
              </a>
            ) : (
              <NavLink
                key={label}
                to={to}
                className="mobile-nav-link"
                onClick={() => setOpen(false)}
              >
                {label}
              </NavLink>
            )
          )}
        </div>
      )}
    </header>
  );
}
